import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useApi from '../../hooks/useApi';
import { compare } from '../../utils/categories';
import useCategories from '../../hooks/useCategories';
import Form, { FormInput } from '../common/Form';
//
// Компонент выводит списки категорий мероприятия как на странице мероприятия,
// но с возможностью выбора категорий.
//
const PresetCategories = ({ event, cats, setCats }) => {
    const [ params ] = useState({ event: event._id });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/categories', params });
    const { addon, admin, folders, orphans } = useCategories({ categories: data?.categories });

    if(error || isLoading) return null;

    return (
    <Form>
        <CategoriesMain folders={folders} orphans={orphans} cats={cats} setCats={setCats}/>
        <CategoriesOther list={addon} header='eventview.cataddon' cats={cats} setCats={setCats}/>
        <CategoriesOther list={admin} header='eventview.catadmin' cats={cats} setCats={setCats}/>
    </Form>
	);
};

PresetCategories.propTypes = {
    event: PropTypes.object.isRequired,
    cats: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCats: PropTypes.func.isRequired,
};

//
// Выводит основную категорию
//
const CategoriesMain = ({ folders, orphans, cats, setCats }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;

    if(!folders.length && !orphans.length) return null;

    return (
        <div>
            {folders.map(item => (
                <fieldset key={item._id}>
                    <legend>{item.name[lang]}</legend>
                    <CategoriesList list={item.categories} cats={cats} setCats={setCats}/>
                </fieldset>
            ))}
            {orphans.length > 0 &&
            <fieldset>
                <legend>{t('eventview.nofolder')}</legend>
                <CategoriesList list={orphans} cats={cats} setCats={setCats}/>
            </fieldset>}
        </div>
    );
};

//
// Выводит списк категорий admin или addon
//
const CategoriesOther = ({ list, header, cats, setCats }) => {
    const { t } = useTranslation();
    if(!list.length) return null;
    return (
        <fieldset>
            <legend>{t(header)}</legend>
            <CategoriesList list={list} cats={cats} setCats={setCats}/>
        </fieldset>
    );
};

//
// Выводит список категорий
//
const CategoriesList = ({ list, cats, setCats }) => {
	const { i18n } = useTranslation();
    const lang = i18n.language;
    const [ sorted, setSorted ] = useState([]);

    useEffect(() => {
        list.sort((a, b) => compare(a, b, lang));
        setSorted(list);
    }, [ list, lang ]);

    const onChange = (cat) => {
        const index = cats.indexOf(cat._id);
        let newCats = [...cats];
        if(index < 0) {
            newCats.push(cat._id);
        } else {
            newCats.splice(index, 1);
        }
        setCats(newCats);
    };

    if(!list.length) return null;

    return(
    <>
        {sorted.map(item => (
            <FormInput
                id={`cat-${item._id}`}
                key={item._id}
                type='checkbox'
                value={cats.includes(item._id) ? item._id : ''}
                label={item.name[lang]}
                onChange={() => onChange(item)}
            />
        ))}
    </>
    );
};

export default PresetCategories;
